import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import { FaPlus } from 'react-icons/fa'
import { filesURL } from '../config/globals'
import AddMarkerModal from "../components/AddMarkerModal"

const ModelViewer3d = (props) => {
    const [isAddMarkModalShown, setIsAddMarkModalShown] = useState(false)
    const [isAddingMark, setIsAddingMark] = useState(false)
    const [activeMark, setActiveMark] = useState(null)

    const modelRef = React.useRef()

    const openAddMarkModal = () => setIsAddMarkModalShown(true)

    const closeAddMarkModal = () => {
        setIsAddMarkModalShown(false)
        setIsAddingMark(false)
        setActiveMark(null)
    }

    const openMark = (id) => {
        const mark = props.record.markers.find(mark => mark.id === id)
        setActiveMark(mark)
        setIsAddMarkModalShown(true)
    }

    const handleClick = (event) => {
        if (!isAddingMark || !modelRef.current) {
            return
        }

        const { clientX, clientY } = event;
        const point = modelRef.current.positionAndNormalFromPoint(clientX, clientY);
        
        if (!point) {
            return
        }

        console.log(props.currentCategory)

        setActiveMark({
            id: props.record.markers ? props.record.markers.length + 1 : 0,
            category: props.currentCategory,
            type: "goodCondition",
            title: "",
            description: "",
            point: point
        })
        openAddMarkModal()
    };

    const getMarkPosition = (mark) => {
        return `${mark.position.x} ${mark.position.y} ${mark.position.z}`;
    }

    const getMarkNormal = (mark) => {
        return `${mark.normal.x} ${mark.normal.y} ${mark.normal.z}`;
    }

    const saveMarker = (form) => {
        closeAddMarkModal()

        if (form.createdAt) {
            props.onUpdateMarker(form)
            return
        }
        
        const mark = activeMark
        mark.title = form.title
        mark.description = form.description
        mark.type = form.type
        mark.category = form.category
        mark.image = form.image
        mark.createdAt = (new Date()).toISOString()
        props.onAddMarker(mark)
    }

    return (
        <>
            <div className="model-viewer-box">
                <div className="model-viewer-gui">
                    {props.allowNewMarkers &&
                        <Button
                            variant={isAddingMark ? "primary" : "outline-primary"}
                            className="toggleButton"
                            onClick={(e) => setIsAddingMark(!isAddingMark)}
                        >
                            <FaPlus /> Add Mark
                        </Button>
                    }
                </div>
                <model-viewer
                    src={`${filesURL}/${props.modelFileName}`}
                    alt="A rock"
                    camera-controls
                    disable-pan
                    disable-zoom
                    onClick={handleClick}
                    ref={ref => modelRef.current = ref}
                >
                {/* <model-viewer
                    src={`${filesURL}/${props.modelFileName}`}
                    alt="A rock"
                    camera-controls
                    auto-rotate
                    rotation-per-second="30deg"
                    disable-pan
                    onClick={handleClick}
                    ref={ref => modelRef.current = ref}
                > */}
                    {props.record.markers && props.record.markers.map(mark => (
                        <button
                            key={`hotspot-${mark.id}`}
                            className={`annotation-mark annotation-mark-${mark.type}`}
                            slot={`hotspot-${mark.id}`}
                            data-position={getMarkPosition(mark.point)}
                            data-normal={getMarkNormal(mark.point)}
                            onClick={e => {
                                e.preventDefault()
                                openMark(mark.id)
                            }}
                        >
                            {mark.id}
                        </button>
                    ))}
                </model-viewer>
            </div>
            <AddMarkerModal 
                isAddMarkModalShown={isAddMarkModalShown}
                activeMark={activeMark}
                onCloseAddMarkModal={closeAddMarkModal}
                onSaveMarker={saveMarker}
            />
        </>
    )
}

export default ModelViewer3d